const Level = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/papr/level',
      name: 'papr_level',
      component: Level
    }
  ]
}
